export enum ComponentsList
{
    Grid = 'ShortCodesTypesGrid',
    List = 'ShortCodesListOfGivenType',
    Form = 'ShortCodesFormOfGivenType'
}
